import { render, staticRenderFns } from "./QuizSession.vue?vue&type=template&id=d4beba78&scoped=true"
import script from "./QuizSession.vue?vue&type=script&lang=js"
export * from "./QuizSession.vue?vue&type=script&lang=js"
import style0 from "./QuizSession.vue?vue&type=style&index=0&id=d4beba78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4beba78",
  null
  
)

export default component.exports